export default __webpack_public_path__ + "static/media/gift.e4af60ed.svg";